import { HeaderGridRow } from 'ui/indexPages/tables/grid';
import { useSortingContext } from 'utils/contexts/sorting';

import { TableHeaderButton } from './TableHeaderButton';
import { useTableContext } from '../../contexts/Table';

export const testIds = {
  header: 'df-table-header',
  headerButton: 'df-table-header-button',
};

export const TableHeader = () => {
  const { sortBy, sortDirection, setSortBy, setSortDirection } = useSortingContext();
  const { columns, gridLayout } = useTableContext();

  return (
    <HeaderGridRow gridLayout={gridLayout} data-test={testIds.header}>
      {columns.map((column) => (
        <TableHeaderButton
          data-test={`${testIds.headerButton}-${column.id}`}
          id={column.id}
          isActiveSortColumn={column.id === sortBy}
          isSortable={!!column.isSortable}
          key={column.id}
          label={column.label}
          onSortByChange={setSortBy}
          onSortDirectionChange={setSortDirection}
          sortDirection={sortDirection}
        />
      ))}
    </HeaderGridRow>
  );
};
